export const round = (num, degree=2) => {
    num= +num;
    if(isNaN(num)) return "";
    return +(Math.round(num + `e+${degree}`)  + `e-${degree}`);
};